import React, { useContext } from "react";
import "./Next.scss";
import { ReactComponent as Icon } from "../../assets/media/arrow.svg";
import { I18nContext } from "../../context";

/**
 * Arrow down button to get to next section
 * @param {Object} props
 * @param {Function} props.onClick Callback
 * @param {String} [props.variant] Style variant
 * @returns {React.ReactElement}
 */
function Next({ onClick, variant }) {
  const { locale } = useContext(I18nContext);

  return (
    <button
      className={`Next ${variant ? `Next--${variant}` : ""}`}
      type="button"
      onClick={onClick}
      aria-label={locale.foo}
    >
      <Icon className="Next__icon" />
    </button>
  );
}

export default Next;
